import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { api, formatApiErrorDetail } from "../lib/api";
import { AuthShell, Field } from "./Login";

const btn = "w-full py-3 rounded-full bg-wyd-accent text-wyd-bg font-semibold hover:glow-magenta transition-shadow duration-300 disabled:opacity-60";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 8) { setError("La password deve avere almeno 8 caratteri"); return; }
    if (password !== confirm) { setError("Le due password non coincidono"); return; }
    setLoading(true);
    try { await api.post("/auth/reset-password", { token, new_password: password }); setDone(true); }
    catch (err) { setError(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  if (!token) {
    return (
      <AuthShell title="Link non valido" subtitle="Il link di recupero è incompleto">
        <Link to="/password-dimenticata" data-testid="reset-request-new" className="text-wyd-accent font-medium">Richiedi un nuovo link</Link>
      </AuthShell>
    );
  }

  return (
    <AuthShell title="Nuova password" subtitle="Scegli una password di almeno 8 caratteri">
      {done ? (
        <div data-testid="reset-success" className="text-center py-4">
          <CheckCircle2 className="mx-auto text-wyd-accent" size={36} />
          <p className="mt-4 text-wyd-muted text-sm">Password aggiornata. Ora puoi accedere.</p>
          <Link to="/login" data-testid="reset-go-login" className={`${btn} block mt-6`}>Accedi</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
          <Field label="Nuova password" type="password" value={password} onChange={setPassword} testid="reset-password" />
          <Field label="Conferma password" type="password" value={confirm} onChange={setConfirm} testid="reset-confirm" />
          {error && <p data-testid="reset-error" className="text-sm text-red-300">{error}</p>}
          <button data-testid="reset-submit" disabled={loading} className={btn}>{loading ? "Salvataggio..." : "Salva password"}</button>
        </form>
      )}
    </AuthShell>
  );
}
